import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import FooterSection from "../components/sections/FooterSection";
import { legalDocuments } from "../data/legalContent";
import Seo from "../seo/Seo";
import { pageMetadata } from "../seo/metadata";

export default function LegalPage({ documentKey }) {
	const document = legalDocuments[documentKey];
	const updatedDate = new Date(`${document.updatedAt}T00:00:00Z`).toLocaleDateString("en-US", {
		year: "numeric", month: "long", day: "numeric", timeZone: "UTC",
	});

	return (
		<>
			<Seo metadata={pageMetadata[documentKey]} />
			<Navbar />
			<main id="main-content" className="legal-page min-h-screen pt-28 md:pt-36 pb-24 md:pb-32" aria-labelledby="legal-heading">
				<article className="container mx-auto px-4 sm:px-6 max-w-3xl">
					<nav aria-label="Legal documents" className="legal-nav flex flex-wrap gap-6 mb-10">
						{Object.entries(legalDocuments).map(([key, { path, title }]) => (
							<Link key={key} to={path} aria-current={key === documentKey ? "page" : undefined}>{title}</Link>
						))}
					</nav>
					<header className="mb-10">
						<p className="font-display font-bold uppercase mb-4" style={{ color: "var(--color-accent)", letterSpacing: "var(--tracking-label)" }}>Racketly</p>
						<h1 id="legal-heading" className="font-display font-bold uppercase mb-6" style={{ fontSize: "var(--text-display)", lineHeight: "var(--lh-tight)" }}>{document.title}</h1>
						<p style={{ color: "var(--color-on-night-muted)", fontSize: "var(--text-sm)" }}>Last updated: <time dateTime={document.updatedAt}>{updatedDate}</time></p>
					</header>
					<details className="legal-contents mb-10">
						<summary className="font-display font-bold uppercase cursor-pointer">On this page</summary>
						<nav aria-label="Table of contents" className="mt-4">
							<ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
								{document.sections.map(({ id, title }) => <li key={id}><a href={`#${id}`}>{title}</a></li>)}
							</ul>
						</nav>
					</details>
					<div className="blog-prose legal-prose">
						{document.introduction}
						{document.sections.map(({ id, title, content }) => (
							<section key={id} aria-labelledby={id}>
								<h2 id={id}>{title}</h2>
								{content}
							</section>
						))}
					</div>
				</article>
			</main>
			<FooterSection isDark={true} />
		</>
	);
}
